(function () {
  'use strict';

  var WHATSAPP_BASE_URL = 'https://api.whatsapp.com/send?phone=601120958533';
  var CHAIR_QUANTITIES = [4, 6, 8, 10];

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-MY', {
      style: 'currency', currency: 'MYR', minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(cents / 100);
  }

  function calculatePrice(chairPrice, chairCompareAt, chairQuantity, tablePrice, tableCompareAt, setDiscountRinggit, roundingRinggit) {
    var chairCurrent = chairPrice * chairQuantity;
    var chairCompare = Math.max(chairCompareAt || chairPrice, chairPrice) * chairQuantity;
    var safeTableCompareAt = Math.max(tableCompareAt || tablePrice, tablePrice);
    var currentTotal = chairCurrent + tablePrice;
    var compareTotal = chairCompare + safeTableCompareAt;
    var setDiscountCents = Math.max(0, Number(setDiscountRinggit)) * 100;
    var discounted = Math.max(0, currentTotal - setDiscountCents);
    var roundingCents = Math.max(1, Number(roundingRinggit)) * 100;
    var total = Math.ceil(discounted / roundingCents) * roundingCents;

    return {
      chairCurrent: chairCurrent,
      chairCompare: chairCompare,
      tableCurrent: tablePrice,
      tableCompare: safeTableCompareAt,
      compareTotal: compareTotal,
      currentTotal: currentTotal,
      setSavings: Math.max(0, currentTotal - total),
      totalSavings: Math.max(0, compareTotal - total),
      total: total
    };
  }

  function priceSelection(data, chair, table, variant, quantity) {
    var pricing = calculatePrice(chair.price, chair.compareAtPrice, quantity, variant.price, variant.compareAtPrice, data.setDiscountRinggit, data.roundingRinggit);
    var match = (data.packages || []).find(function (pack) {
      return String(pack.chairProductId) === String(chair.productId) &&
        String(pack.chairVariantId) === String(chair.variantId) &&
        String(pack.tableProductId) === String(table.productId) &&
        String(pack.tableVariantId) === String(variant.id) &&
        Number(pack.quantity) === Number(quantity) &&
        Number.isFinite(pack.price) && pack.price > 0;
    });
    if (match) {
      pricing.total = match.price;
      pricing.setSavings = Math.max(0, pricing.currentTotal - pricing.total);
      pricing.totalSavings = Math.max(0, pricing.compareTotal - pricing.total);
    }
    pricing.isPackage = Boolean(match);
    return pricing;
  }

  function parseData(root) {
    var dataElement = root.querySelector('[data-builder-data]');
    if (!dataElement) return null;
    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Dining set builder data could not be read.', error);
      return null;
    }
  }

  function renderChoices(container, choices, selectedValue, onSelect) {
    container.innerHTML = '';
    choices.forEach(function (choice) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'dining-builder__choice';
      button.textContent = choice.label;
      button.dataset.value = String(choice.value);
      button.setAttribute('aria-pressed', String(String(choice.value) === String(selectedValue)));
      button.addEventListener('click', function () { onSelect(choice.value); });
      container.appendChild(button);
    });
  }

  function renderSizeChoices(container, variants, selectedValue, data, onSelect) {
    container.innerHTML = '';
    variants.forEach(function (variant) {
      var button = document.createElement('button');
      var title = document.createElement('span');
      var priceLine = document.createElement('span');
      var currentPrice = document.createElement('strong');

      button.type = 'button';
      button.className = 'dining-builder__size-choice';
      button.dataset.value = String(variant.id);
      button.setAttribute('aria-pressed', String(String(variant.id) === String(selectedValue)));

      title.className = 'dining-builder__size-title';
      title.textContent = variant.title;
      priceLine.className = 'dining-builder__size-price';
      currentPrice.textContent = data.priceFromLabel + ' ' + formatMoney(variant.price);
      priceLine.appendChild(currentPrice);

      if (variant.compareAtPrice > variant.price) {
        var comparePrice = document.createElement('s');
        comparePrice.textContent = data.wasLabel + ' ' + formatMoney(variant.compareAtPrice);
        priceLine.appendChild(comparePrice);
      }

      button.appendChild(title);
      button.appendChild(priceLine);
      button.addEventListener('click', function () { onSelect(variant.id); });
      container.appendChild(button);
    });
  }

  function setProductPreview(root, prefix, product, variant) {
    var image = root.querySelector('[data-' + prefix + '-image]');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.setAttribute('src', product.image);
    image.alt = product.title;
    root.querySelector('[data-' + prefix + '-title]').textContent = product.title;
    root.querySelector('[data-' + prefix + '-current-price]').textContent = formatMoney(variant.price);
    root.querySelector('[data-' + prefix + '-compare-price]').textContent = formatMoney(Math.max(variant.compareAtPrice || variant.price, variant.price));

    var productLink = root.querySelector('[data-' + prefix + '-product-link]');
    if (productLink) productLink.href = product.url;

    var triggerImage = root.querySelector('[data-' + prefix + '-trigger-image]');
    var triggerTitle = root.querySelector('[data-' + prefix + '-trigger-title]');
    if (triggerImage) {
      triggerImage.removeAttribute('srcset');
      triggerImage.removeAttribute('sizes');
      triggerImage.setAttribute('src', product.image);
      triggerImage.alt = '';
    }
    if (triggerTitle) triggerTitle.textContent = product.title;
  }

  function initBuilder(root) {
    var data = parseData(root);
    if (!data || !data.chairs.length || !data.tables.length) {
      var error = root.querySelector('[data-builder-error]');
      if (error) error.hidden = false;
      return;
    }

    var state = {
      chairHandle: data.chairs[0].handle,
      tableHandle: data.tables[0].handle,
      variantId: data.tables[0].variants[0].id,
      quantity: 4
    };

    var chairPicker = root.querySelector('[data-chair-picker]');
    var tablePicker = root.querySelector('[data-table-picker]');
    var chairOptions = Array.prototype.slice.call(root.querySelectorAll('[data-chair-option]'));
    var tableOptions = Array.prototype.slice.call(root.querySelectorAll('[data-table-option]'));
    var sizeChoices = root.querySelector('[data-size-choices]');
    var quantityChoices = root.querySelector('[data-quantity-choices]');
    var whatsapp = root.querySelector('#whatsapp-contact-link');

    function setupPickerSearch(picker, options) {
      var search = picker.querySelector('[data-picker-search]');
      var empty = picker.querySelector('[data-picker-empty]');

      function filterOptions() {
        var query = search.value.trim().toLowerCase();
        var visibleCount = 0;
        options.forEach(function (option) {
          var matches = !query || option.dataset.searchText.indexOf(query) !== -1;
          option.hidden = !matches;
          if (matches) visibleCount += 1;
        });
        empty.hidden = visibleCount !== 0;
      }

      search.addEventListener('input', filterOptions);
      search.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') picker.open = false;
      });

      return function resetSearch() {
        search.value = '';
        filterOptions();
      };
    }

    var resetChairSearch = setupPickerSearch(chairPicker, chairOptions);
    var resetTableSearch = setupPickerSearch(tablePicker, tableOptions);

    chairPicker.addEventListener('toggle', function () {
      if (chairPicker.open) tablePicker.open = false;
    });
    tablePicker.addEventListener('toggle', function () {
      if (tablePicker.open) chairPicker.open = false;
    });

    function currentChair() {
      return data.chairs.find(function (chair) { return chair.handle === state.chairHandle; });
    }

    function currentTable() {
      return data.tables.find(function (table) { return table.handle === state.tableHandle; });
    }

    function currentVariant() {
      return currentTable().variants.find(function (variant) {
        return String(variant.id) === String(state.variantId);
      });
    }

    function updateWhatsapp(chair, table, variant, pricing) {
      whatsapp.href = WHATSAPP_BASE_URL;
      window.GH_DINING_BUILDER_WHATSAPP_DATA = {
        productId: 'dining-set-builder',
        productTitle: state.quantity + ' × ' + chair.title + ' + ' + table.title,
        variantId: String(chair.variantId) + ':' + String(variant.id) + ':' + String(state.quantity),
        variantTitle: variant.title + ' | ' + data.messageSavings + ': ' + formatMoney(pricing.totalSavings),
        variant: 'Custom Dining Set',
        price: (pricing.total / 100).toFixed(2)
      };
    }

    function renderSummary() {
      var chair = currentChair();
      var table = currentTable();
      var variant = currentVariant();
      var pricing = priceSelection(data, chair, table, variant, state.quantity);

      root.querySelector('[data-summary-chair]').textContent = state.quantity + ' × ' + chair.title;
      root.querySelector('[data-summary-table]').textContent = table.title + ' · ' + variant.title;
      root.querySelector('[data-compare-total]').textContent = formatMoney(pricing.compareTotal);
      root.querySelector('[data-current-total]').textContent = formatMoney(pricing.currentTotal);
      root.querySelector('[data-set-savings]').textContent = '−' + formatMoney(pricing.setSavings);
      root.querySelector('[data-total-savings]').textContent = formatMoney(pricing.totalSavings);
      root.querySelector('[data-total]').textContent = formatMoney(pricing.total);
      root.querySelector('.dining-builder__total-label').textContent = pricing.isPackage ? data.packagePriceLabel : data.estimatedPriceLabel;
      root.querySelector('.dining-builder__price-row--saving').style.display = pricing.setSavings > 0 ? '' : 'none';
      root.querySelector('.dining-builder__total-saving').style.display = pricing.totalSavings > 0 ? '' : 'none';
      setProductPreview(root, 'chair', chair, chair);
      setProductPreview(root, 'table', table, variant);
      chairOptions.forEach(function (option) {
        option.setAttribute('aria-pressed', String(option.dataset.chairOption === chair.handle));
      });
      tableOptions.forEach(function (option) {
        option.setAttribute('aria-pressed', String(option.dataset.tableOption === table.handle));
      });
      renderCapacityWarning(variant);
      updateWhatsapp(chair, table, variant, pricing);
    }

    function renderCapacityWarning(variant) {
      var warning = root.querySelector('[data-capacity-warning]');
      var recommended = Array.isArray(variant.recommendedQuantities)
        ? variant.recommendedQuantities.map(Number)
        : [];
      var shouldWarn = recommended.length > 0 && recommended.indexOf(state.quantity) === -1;

      warning.hidden = !shouldWarn;
      if (shouldWarn) {
        warning.textContent = data.capacityWarning
          .replace('[quantity]', String(state.quantity))
          .replace('[recommended]', recommended.join(' or '));
      }
    }

    function renderQuantities() {
      renderChoices(quantityChoices, CHAIR_QUANTITIES.map(function (quantity) {
        return { label: quantity + ' ' + data.chairLabel, value: quantity };
      }), state.quantity, function (quantity) {
        state.quantity = Number(quantity);
        renderQuantities();
        renderSummary();
      });
    }

    function renderSizes() {
      var table = currentTable();
      var variants = table.variants.filter(function (variant) { return variant.available; });
      if (!variants.some(function (variant) { return String(variant.id) === String(state.variantId); })) state.variantId = variants[0].id;

      renderSizeChoices(sizeChoices, variants, state.variantId, data, function (variantId) {
        state.variantId = variantId;
        renderSizes();
        renderQuantities();
        renderSummary();
      });
    }

    chairOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        state.chairHandle = option.dataset.chairOption;
        resetChairSearch();
        chairPicker.open = false;
        renderSummary();
      });
    });

    tableOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        state.tableHandle = option.dataset.tableOption;
        state.variantId = currentTable().variants[0].id;
        resetTableSearch();
        tablePicker.open = false;
        renderSizes();
        renderQuantities();
        renderSummary();
      });
    });

    renderSizes();
    renderQuantities();
    renderSummary();
  }

  window.GayaHomeDiningBuilder = {
    calculatePrice: calculatePrice,
    priceSelection: priceSelection,
    formatMoney: formatMoney
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dining-builder]').forEach(initBuilder);
  });
})();
